import { Router, Route } from 'preact-router';
import { useEffect, useState } from 'preact/hooks';
import { LoginPage } from './components/pages/LoginPage';
import { ForgotPasswordPage } from './components/pages/ForgotPasswordPage';
import { ResetPasswordPage } from './components/pages/ResetPasswordPage';
import { VerifyEmailPage } from './components/pages/VerifyEmailPage';
import { DashboardPage } from './components/pages/DashboardPage';
import { IssuesPage } from './components/pages/IssuesPage';
import { ProjectDetailPage } from './components/pages/ProjectDetailPage';
import { IssueDetailPage } from './components/pages/IssueDetailPage';
import { ApiKeysPage } from './components/pages/ApiKeysPage';
import { TelegramUsersPage } from './components/pages/TelegramUsersPage';
import { NotFoundPage } from './components/pages/NotFoundPage';
import { token, user } from './stores/authStore';
import { api } from './services/api';

export function App() {
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    // Restore user info if token exists
    const initAuth = async () => {
      if (token.value && !user.value) {
        const response = await api.get<any>('/api/auth/me');
        if (response.success && response.data) {
          user.value = response.data;
        } else {
          // Token is invalid, clear it
          localStorage.removeItem('token');
          token.value = null;
        }
      }
      setInitializing(false);
    };

    initAuth();
  }, []);

  if (initializing) {
    return (
      <div class="flex min-h-screen items-center justify-center bg-gray-100">
        <div class="text-center">
          <div class="mb-4 text-xl font-semibold">Loading...</div>
          <div class="text-sm text-gray-600">Initializing Issue Tracker</div>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Route path="/" component={LoginPage} />
      <Route path="/login" component={LoginPage} />
      <Route path="/forgot-password" component={ForgotPasswordPage} />
      <Route path="/reset-password" component={ResetPasswordPage} />
      <Route path="/verify-email" component={VerifyEmailPage} />
      <Route path="/dashboard" component={DashboardPage} />
      <Route path="/projects/:id" component={ProjectDetailPage} />
      <Route path="/issues/:id" component={IssueDetailPage} />
      <Route path="/issues" component={IssuesPage} />
      <Route path="/api-keys" component={ApiKeysPage} />
      <Route path="/admin/telegram-users" component={TelegramUsersPage} />
      <Route default component={NotFoundPage} />
    </Router>
  );
}
